<style scoped>
  section { background: whitesmoke; margin-top: 100px; height: 155px; }
  .permissoes { margin: auto; width: 300px; }
</style>

<template>
    <section>
      <div class="permissoes has-text-centered">
        <div class="animated fadeIn" v-if="falha">
          <b-icon icon="block" size="is-large" />
          <p class="m-t">Houve um problema ao recuperar permissões</p>
          <p class="m-t">{{ mensagem.message }}</p>
          <button class="button m-t is-fullwidth" @click="login">
            <b-icon icon="arrow_back"/>
            <span>Autenticar novamente</span>
          </button>
        </div>

        <portal-loading class="m-t" :loading="!falha" message="Buscando permissões de acesso..."/>
      </div>
    </section>
</template>

<script>
  export default {
    props: ['url', 'to'],
    created () {
      let usuario = this.$air.usuarioLogado()
      if (usuario !== undefined && usuario !== null && usuario.token !== null && usuario.token !== undefined) {
        this.falha = false
        this.$http.get(this.url, this.$header()).then(res => {
          this.$salvarPermissoes(res.body)
          this.$root.$emit('acessar')
          this.$router.push(this.to)
        }, res => {
          this.mensagem = res.body
          this.falha = true
        })
      } else {
        this.$router.push('/login')
      }
    },
    data () {
      return {
        falha: false,
        mensagem: ''
      }
    },
    methods: {
      login () {
        this.$router.push('/login')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PortalPermissoes.vue